import { Box, Chip } from '@mui/material';
import {
  TrendyolOrderStatus,
  trendyolOrderStatusDescriptionMap,
  trendyolOrderStatusNameMap,
} from '../../../interfaces/Trendyol/TrendyolOrderStatus';
import { TrendyolOrder } from '../../../interfaces/Trendyol/TrendyolOrder';

interface TrendyolStatusCellProps {
  order: TrendyolOrder;
}

export const TrendyolStatusCell = (props: TrendyolStatusCellProps) => {
  const getColor = () => {
    switch (props.order.status) {
      case TrendyolOrderStatus.CREATED:
        return 'success';
      default:
        return 'error';
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <Chip
        size='small'
        variant='filled'
        color={getColor()}
        label={trendyolOrderStatusNameMap[props.order.status]}
      />

      <Chip
        size='small'
        variant='filled'
        color={getColor()}
        label={trendyolOrderStatusDescriptionMap[props.order.status]}
      />

      {props.order.status === TrendyolOrderStatus.CREATED &&
        (props.order.shipmentImages.length > 0 ? (
          <Chip
            size='small'
            variant='filled'
            color='success'
            label='Hazırlandı'
          />
        ) : (
          <Chip
            size='small'
            variant='filled'
            color='primary'
            label='Hazırlanabilir'
          />
        ))}
    </Box>
  );
};
